import React, { useEffect, useState } from 'react'
import { Card } from 'component'
import StyleMultiGraph from 'component/waterfall.card/style/styleMultiGraph'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import { convertParams } from 'component/util'
import Button from 'meinian-package/src/baseComponent/button'
import UploadIns from 'meinian-package/src/component/uploadIns'
import { VIEW_MODE } from '../../../components/fixedOperation'
import { RULES, getRules } from '../../../components/fixedOperation/imageSize'
import { getViewConfig } from '../../../../component/navUser/viewSettingModal'
import { CooperationMember } from '../infoWrap'

const TAB = { ALL: '1', STYLE: '3', DATA_ANALYSIS: '4', USER_ANALYSIS: '5', SAMPLE: '7' }

export default ({
  viewMode,
  params,
  query,
  tab,
  $masonry,
  setBatchAll,
  defaultParams,
  batchValue,
  info,
  fetchInfo,
  columnRulesType,
  disabledIsEnd,
}) => {
  const auth = info.loginUserInfo?.inspirationPermissions || []
  const isChild = info.parentId && info.parentId !== -1

  const [viewConfig, setViewConfig] = useState({})

  useEffect(() => {
    getViewConfig().then(res => {
      setViewConfig(res)
    })
  }, [])

  return <MNWaterfallApi
    disabledIsEnd={disabledIsEnd}
    renderItem={(props) => {
      if (viewMode === VIEW_MODE.MULTI_GRAPH) {
        return <StyleMultiGraph {...props} />
      }
      if (viewMode === VIEW_MODE.IMAGE) {
        return <Card.Image {...props} />
      }
      if (viewMode === VIEW_MODE.TEXT) {
        return <Card.ImageText {...props} />
      }
      return <Card.Image {...props} />
    }}
    rule={viewMode === VIEW_MODE.IMAGE ? getRules(columnRulesType) : RULES.M}
    onTotal={() => fetchInfo(isChild)}
    idKey={['imageGroupEntityId', 'inspirationId']}
    cardKey={i => `${i.imageGroupEntityId}${i.inspirationId}`}
    cardProps={{
      isBatch: batchValue,
      shareUrl: query.shareUrl,
      lajiInspirationId: info.id,
      initSubColls: () => {
        fetchInfo(isChild)
      },
      showMoveImage: true,
      viewConfig,
    }}
    url={!auth.includes('F02') ? '/zhikuan/image-bus/inspiration/list-share-blog'
      : '/zhikuan/image-bus/inspiration/list-blog'}
    method="post"
    params={{
      ...defaultParams,
      ...convertParams(params),
      shareUrl: query.shareUrl,
      inspirationId: info.id,
      upStyleFlag: tab === TAB.STYLE ? 1 : params.upStyleFlag,
      keyWords: query.like,
      trackSourceType: '灵感集详情页',
    }}
    ref={$masonry}
    afterLoad={data => setBatchAll(data)}
    emptyText={<div>
      <div>暂无款式，开始采集</div>
      <div style={{ marginTop: '16px' }}>
        {!isChild && <CooperationMember info={info} onInit={fetchInfo} auth={auth} text="邀请团队成员加入" />}
        <Button
          type="primary"
          style={{ marginLeft: '8px' }}
          onClick={() => {
            UploadIns.Show({
              inspirationId: query.inspirationId ? Number(query.inspirationId) : null,
              callback: () => {
                $masonry.current?.init()
              }
            })
          }}
        >上传本地图片</Button>
      </div>
    </div>}
    emptyType="image"
  />
}
